export interface LoyaltyTier {
  name: string;
  minPoints: number;
  color: string;
  bg: string;
  badge: string;
  discount: number; // % extra discount on all orders
  perks: string[];
}

export const LOYALTY_TIERS: LoyaltyTier[] = [
  {
    name: 'Bronze',
    minPoints: 0,
    color: 'text-amber-700',
    bg: 'bg-amber-100',
    badge: '🥉',
    discount: 0,
    perks: ['Earn 1 pt per ₹10', 'Birthday bonus'],
  },
  {
    name: 'Silver',
    minPoints: 500,
    color: 'text-gray-600',
    bg: 'bg-gray-100',
    badge: '🥈',
    discount: 2,
    perks: ['2% extra discount', 'Priority support', 'Early sale access'],
  },
  {
    name: 'Gold',
    minPoints: 2000,
    color: 'text-yellow-600',
    bg: 'bg-yellow-100',
    badge: '🥇',
    discount: 5,
    perks: ['5% extra discount', 'Free delivery always', 'Dedicated pharmacist'],
  },
  {
    name: 'Platinum',
    minPoints: 5000,
    color: 'text-purple-700',
    bg: 'bg-purple-100',
    badge: '💎',
    discount: 10,
    perks: ['10% extra discount', 'VIP support', 'Home medicine delivery', 'Quarterly health check'],
  },
];

export function getTier(points: number): LoyaltyTier {
  return [...LOYALTY_TIERS].reverse().find(t => points >= t.minPoints) || LOYALTY_TIERS[0];
}

export function getNextTier(points: number): LoyaltyTier | null {
  const next = LOYALTY_TIERS.find(t => t.minPoints > points);
  return next || null;
}

export function getProgressToNext(points: number): number {
  const current = getTier(points);
  const next = getNextTier(points);
  if (!next) return 100;
  const range = next.minPoints - current.minPoints;
  const earned = points - current.minPoints;
  return Math.round((earned / range) * 100);
}
